module.exports = __webpack_public_path__ + "img/chevron-green.233d3b93.svg";